import { useState } from "react"; 
import { TextInput, SimpleForm, NumberInput, useNotify, required } from "react-admin";  
import { updateResellerWalletAmount } from ".";
export function UpdateResellerWallet() {
  const notify = useNotify();
  const [adminId, setAdminId] = useState(""); 
  const [walletAmount, setWalletAmount] = useState(""); 

  const handleSubmit = async (e: any) => {  
 
    const request: any = {
      adminId,
      walletAmount: Number(walletAmount),
    }; 

    try {
      const response = await updateResellerWalletAmount(request);  
      if (response.status === "200") {
        notify(" کیف پول مربی با موفقیت شارژ شد!", { type: "success" });
      } else {
        notify("خطا در شارژ کیف پول مربی!", { type: "error" });
      }
    } catch (error) {
      notify("خطا در ارسال اطلاعات!", { type: "error" });
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <h2 style={{marginRight:'1rem'}}>شارژ کیف پول مربی</h2> 
      <SimpleForm save={handleSubmit}>
        <TextInput 
          label="شناسه مربی" 
          source="adminUsername" 
          value={adminId} 
          onChange={(e: any) => setAdminId(e.target.value)} 
          validate={required("شناسه الزامی است")}
        /> 
        
        <NumberInput 
          label="میزان شارژ کیف پول" 
          source="walletAmount" 
          value={walletAmount} 
          onChange={(e: any) => setWalletAmount(e.target.value)} 
          min={0} 
        />
      </SimpleForm>
    </div>
  );
}
